import { gql } from 'apollo-angular';

export const GET_VEHICLE_MODIFICATIONS_BY_LICENSE_PLATE = gql`
  query GetVehicleModificationsByLicensePlate(
    $input: VehicleModificationByLicensePlateInput!
  ) {
    vehicleModificationsByLicensePlate(input: $input) {
      id
      name
      vehicleType
      manufacturer {
        id
        name
        shortName
      }
      model {
        id
        name
      }
      beginYearMonth
      endYearMonth
      period
      images {
        url50
        url100
        url200
        url400
        url800
      }
      kbaNumbers
      driveType {
        id
        name
      }
      bodyStyle {
        id
        name
      }
      valves
      fuelMixtureFormationType {
        id
        name
      }
      fuelType {
        id
        name
      }
      engineType {
        id
        name
      }
      powerHp
      powerKw
      cylinders
      capacity {
        cc
        liters
      }
      engines {
        id
        code
      }
    }
  }
`;
